import { useEffect, useState, useCallback } from 'react';

export function useFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const isDomFullscreen = () => !!document.fullscreenElement;

  const isBrowserFullscreen = () => {
    return Math.abs(window.innerHeight - window.screen.height) < 5;
  };

  const syncState = () => {
    setIsFullscreen(isDomFullscreen() || isBrowserFullscreen());
  };

  const enterFullscreen = useCallback(async () => {
    if (!document.fullscreenElement) {
      await document.documentElement.requestFullscreen();
    }
  }, []);

  const exitFullscreen = useCallback(async () => {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    } else {
      syncState();
    }
  }, []);

  useEffect(() => {
    syncState();

    document.addEventListener('fullscreenchange', syncState);
    window.addEventListener('resize', syncState);

    return () => {
      document.removeEventListener('fullscreenchange', syncState);
      window.removeEventListener('resize', syncState);
    };
  }, []);

  return {
    isFullscreen,
    enterFullscreen,
    exitFullscreen
  };
}
